import React from 'react'
import styles from './intro.module.css'


export default function Intro() {

 
  
  return (
    <div className={styles.intro}>
      <div className={styles.container}>
        <p className={styles.title}>My portfolio</p>
        <p className={styles.sub}>A portfolio of Ryo Aoyama</p>
        <p className={styles.sub2}>Web developer</p>
      </div>
      <div className={styles.hr}></div>
    </div>
  )
}
